import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import i18n from "@/i18n";
import App from "@/App";
import { captureAcquisition } from "@/lib/acquisition";
import { applyLangParam } from "@/lib/lang";

// T22. Before anything renders: the router may redirect on its first pass, and
// the UTMs live in the URL it is about to replace.
captureAcquisition();
// T23. Same reason, and the first paint should already be in that language.
applyLangParam(i18n);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
